import axios from "axios";
import { baseUrl, storeInternationalContact } from "../../utils/apiData";
import { Formik, Form, Field, ErrorMessage } from "formik";
import ErrorLine from "./errorLine/ErrorLine";
import { PrimaryBtn } from "../index";
import * as Yup from "yup";
import { useState } from "react";
import { LiaAngleDownSolid } from "react-icons/lia";
import { countries } from "../../utils/enum";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";

const InternationalForm = ({
  setLoader,
  loader,
  setSuccess,
  typeStatus,
  setTypeStatus,
  countryStatus,
  setCountryStatus,
}) => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [constructionType, setConstructionType] = useState("");

  const [search, setSearch] = useState("");

  const [country, setCountry] = useState("");

  const contactFormapi = async (data) => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${storeInternationalContact}`, {
        ...data,
      });
      if (res?.data?.success) {
        navigate("/thanks");
        setCountry("");
        setPhone("");
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };

  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    message: "",
  };

  const validationSchema = Yup.object({
    first_name: Yup.string().required("fname is required!"),
    last_name: Yup.string().required("lname is required!"),
    email: Yup.string()
      .email("invalid email formate!")
      .required("email is required!"),

    message: Yup.string().required("note is required!"),
  });

  const onSubmit = (values, { resetForm }) => {
    contactFormapi({
      ...values,
      construction_type: constructionType,
      country: country,
      phone: phone,
    });
    resetForm();
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <Form>
        <div className="bi_sec">
          <div className="field_line">
            <label htmlFor="Fname">First name</label>
            <Field
              type="text"
              placeholder="Johan"
              id="Fname"
              name="first_name"
            />
            <ErrorMessage name="first_name" component={ErrorLine} />
          </div>

          <div className="field_line">
            <label htmlFor="Lname">Last name</label>
            <Field type="text" placeholder="Doe" id="Lname" name="last_name" />
            <ErrorMessage name="last_name" component={ErrorLine} />
          </div>
        </div>
        <div className="bi_sec">
          <div className="field_line">
            <label htmlFor="Email">Email</label>
            <Field
              type="email"
              placeholder="example@gmail.com"
              id="Email"
              name="email"
            />
            <ErrorMessage name="email" component={ErrorLine} />
          </div>

          <div className="field_line">
            <label htmlFor="Number">Phone Number</label>
            <PhoneInput
              country={"in"}
              value={phone}
              onChange={(phone) => setPhone(phone)}
            />
          </div>
        </div>

        <div className="bi_sec">
          <div className="field_line">
            <label htmlFor="type">Construction/Investment Type</label>
            <div
              className={`select_wrap_box ${typeStatus ? "active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                setTypeStatus((prev) => !prev);
              }}
            >
              <p>{constructionType ? constructionType : "- Select - "}</p>{" "}
              <LiaAngleDownSolid />
              <div className="dd_list">
                <button
                  type="button"
                  className={constructionType === "Residential" ? "active" : ""}
                  onClick={() => setConstructionType("Residential")}
                >
                  Residential
                </button>
                <button
                  type="button"
                  className={constructionType === "Commercial" ? "active" : ""}
                  onClick={() => setConstructionType("Commercial")}
                >
                  Commercial
                </button>
              </div>
            </div>
          </div>

          <div className="field_line">
            <label htmlFor="type">Country</label>
            <div
              className={`select_wrap_box ${countryStatus ? "active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                setCountryStatus((prev) => !prev);
              }}
            >
              <p>{country ? country : "- Select - "}</p> <LiaAngleDownSolid />
              <div className="dd_list">
                <input
                  type="text"
                  value={search}
                  className="search"
                  placeholder="Search here..."
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
                {countries
                  ?.filter((ele) =>
                    ele.name
                      ?.toLocaleLowerCase()
                      ?.includes(search.toLocaleLowerCase())
                  )
                  ?.map((data, k) => {
                    return (
                      <button
                        type="button"
                        className={country === `${data?.name}` ? "active" : ""}
                        onClick={() => setCountry(`${data?.name}`)}
                        key={k}
                      >
                        {data?.name}
                      </button>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>

        <div className="field_line">
          <label htmlFor="Message">Message</label>
          <Field
            as="textarea"
            type="text"
            placeholder="Write your message here..."
            id="Message"
            name="message"
          />
          <ErrorMessage name="message" component={ErrorLine} />
        </div>

        <PrimaryBtn
          theme="gold"
          type="submit"
          title={loader ? "Loading..." : "Submit"}
        />
      </Form>
    </Formik>
  );
};

export default InternationalForm;
